import React from "react";
import { Link } from "react-router-dom";

import { Button } from "../components/ui/button";

export const NotFound: React.FC = () => (
  <div className="p-6 max-w-xl">
    <h1 className="text-2xl font-bold">Not found</h1>
    <p className="text-sm text-secondary-500 mt-2">
      That page doesn&apos;t exist in MTTR. Maybe one of these?
    </p>
    <div className="mt-4 flex gap-2">
      <Button asChild variant="outline">
        <Link to="/">Dashboard</Link>
      </Button>
      <Button asChild variant="outline">
        <Link to="/boxes">SmartBoxes</Link>
      </Button>
      <Button asChild variant="outline">
        <Link to="/outages">Maintenance</Link>
      </Button>
    </div>
  </div>
);

export default NotFound;
